import { render, staticRenderFns } from "./AggregateLearningLeaderboardMinimizedView.vue?vue&type=template&id=035acb18"
import script from "./AggregateLearningLeaderboardMinimizedView.vue?vue&type=script&lang=js"
export * from "./AggregateLearningLeaderboardMinimizedView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports